// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5RzXl","headerOpt":"Header_headerOpt__OM+Vk"};